import { render, staticRenderFns } from "./accruedtrx.vue?vue&type=template&id=57b03c00"
import script from "./accruedtrx.vue?vue&type=script&lang=js"
export * from "./accruedtrx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports